import { createSlice } from "@reduxjs/toolkit";
import { asyncStatus } from "../../utils/asyncStatus";
import {
  success_toast_message,
  error_toast_message,
} from "../../utils/toast_message";
import { getAllTypes, getAllVariants } from "../../services/variantService";

const initialState = {
  // GET ALL STORES >>>>>>>>>>>>>
  get_variants_status: asyncStatus.IDLE,
  get_variants_data: null,
  get_variants_error: null,
  // GET ALL TYPES >>>>>>>>>>>>>
  get_types_status: asyncStatus.IDLE,
  get_types_data: null,
  get_types_error: null,
};

const variantSlice = createSlice({
  name: "variant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // GET ALL ORDERS >>>>>>>>>>>>>
    builder.addCase(getAllVariants.pending, (state, action) => {
      state.get_variants_status = asyncStatus.LOADING;
    });

    builder.addCase(getAllVariants.fulfilled, (state, { payload }) => {
      state.get_variants_status = asyncStatus.SUCCEEDED;
      state.get_variants_data = payload.data;
    });

    builder.addCase(getAllVariants.rejected, (state, action) => {
      state.get_variants_status = asyncStatus.ERROR;
      state.get_variants_error = action.error;
      error_toast_message(action.error.message);
    });
    // GET ALL TYPES >>>>>>>>>>>>>
    builder.addCase(getAllTypes.pending, (state, action) => {
      state.get_types_status = asyncStatus.LOADING;
    });

    builder.addCase(getAllTypes.fulfilled, (state, { payload }) => {
      state.get_types_status = asyncStatus.SUCCEEDED;
      state.get_types_data = payload.data;
    });

    builder.addCase(getAllTypes.rejected, (state, action) => {
      state.get_types_status = asyncStatus.ERROR;
      state.get_types_error = action.error;
      error_toast_message(action.error.message);
    });
  },
});

export const {} = variantSlice.actions;

export default variantSlice.reducer;
